export const isMidiCopyrightNoticeEvent = (event) => {
    return event.copyrightNotice !== undefined;
};
//# sourceMappingURL=/build/es2019/guards/midi-copyright-notice-event.js.map